
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "app-navigation-panel",
})
export default class extends Vue {}
